import { IStoreReady } from "@/store/lib/storeSupport";
import {
  Action,
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";

import store from "@/store";
import { IWarehouse, IWarehouseItem } from "@/entity/warehouse/Warehouse.types";
import {
  WarehouseAddRequestType,
  WarehouseUpdateRequestType,
} from "@/entity/warehouse/Warehouse";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";
import { prepareFormData } from "@/store/utils/formDataHelper";

@Module({
  namespaced: true,
  name: "warehouse",
  store,
  dynamic: true,
})
class WarehouseModule extends VuexModule implements IStoreReady {
  warehouse: IWarehouse | null = null;
  WarehouseItem: IWarehouseItem | null = null;
  Loaded = false;
  ready = false;

  @MutationAction
  async fetchAll(
    data?: PaginationRequestType
  ): Promise<{ warehouse: IWarehouse; Loaded: boolean }> {
    const warehouse = await store.$repository.warehouse.fetchAll(
      prepareFormData(data)
    );
    let Loaded = false;
    if (warehouse) {
      Loaded = true;
    }
    return { warehouse, Loaded };
  }
  @MutationAction
  async fetchData(
    data: PaginationRequestType
  ): Promise<{ WarehouseItem: IWarehouseItem; Loaded: boolean }> {
    let Loaded = false;
    const WarehouseItem = await store.$repository.warehouse.fetchData(data);
    if (WarehouseItem) {
      Loaded = true;
    }
    return { WarehouseItem, Loaded };
  }

  @Action({ rawError: true })
  async create(data: WarehouseAddRequestType): Promise<ResponseDataType> {
    return await store.$repository.warehouse.create(data);
  }

  @Action({ rawError: true })
  async update(data: WarehouseUpdateRequestType): Promise<ResponseDataType> {
    return await store.$repository.warehouse.update(data);
  }

  @Action({ rawError: true })
  async delete(id: number): Promise<ResponseDataType> {
    return await store.$repository.warehouse.delete({ id: id });
  }

  @Mutation
  setReady(st: boolean) {
    this.ready = st;
  }
}

export const StoresStore = getModule(WarehouseModule);
